import React from "react";
import "./BuildCourageTop.css";

const BuildCourageTop = ({ selectedDrive, setSelectedDrive }) => {
  
  const prices = {
    "2wd": 419900,
    "4wd": 449900,
  };

  const formattedPrice = (value) => value.toLocaleString("no-NO") + " kr";

  return (
    <div className="build-top-wrapper">
      <div className="build-left">
        <h2 className="build-title">Select type</h2>

        {/* 2WD */}
        <div
          className={`build-option ${selectedDrive === "2wd" ? "active" : ""}`}
          onClick={() => setSelectedDrive("2wd")}
        >
          <div className="option-radio">
            <div className={`radio-circle ${selectedDrive === "2wd" ? "checked" : ""}`}></div>
          </div>

          <div className="option-texts">
            <p className="option-title">Two-wheel drive</p>
            <p className="option-price">{formattedPrice(prices["2wd"])}</p>
          </div>
        </div>

        {/* 4WD */}
        <div
          className={`build-option ${selectedDrive === "4wd" ? "active" : ""}`}
          onClick={() => setSelectedDrive("4wd")}
        >
          <div className="option-radio">
            <div className={`radio-circle ${selectedDrive === "4wd" ? "checked" : ""}`}></div>
          </div>

          <div className="option-texts">
            <p className="option-title">Four-wheel drive</p>
            <p className="option-price">{formattedPrice(prices["4wd"])}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuildCourageTop;
